<app-page-header
    title="Gestión de Vehículos"
    mobileTitle="Marcas"
    icon="fas fa-car"
    [showBack]="appSettings.isMobile() && showBrandDetail"
    [unifiedOnMobile]="appSettings.isMobile() && showBrandDetail"
    (back)="closeBrandDetail()">
    @if (appSettings.isMobile() && !showBrandDetail && perm.canCurrent('canCreate')) {
        <button headerExtra type="button" class="btn btn-primary btn-xs" (click)="createNewBrand()">
            <i class="fas fa-plus me-1"></i>Nuevo
        </button>
    }
</app-page-header>

@if (appSettings.isMobile() && showBrandDetail && mode() !== formMode.VIEW) {
<app-mobile-footer [visible]="true">
    <button type="button" class="btn btn-primary btn-sm"
        [disabled]="brandForm.invalid"
        (click)="saveBrand()">
        Guardar
    </button>
</app-mobile-footer>
}

<div class="row">
    @if (!(appSettings.isMobile() && showBrandDetail)) {
    <div [class]="appSettings.isMobile() ? 'col-12 mobile-requests-container' : 'col-md-3'">
        <div class="mobile-list-shell" [class.panel]="!appSettings.isMobile()" [class.p-3]="!appSettings.isMobile()">
            @if (!appSettings.isMobile()) {
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h4 class="mb-0">Listado de Marcas</h4>
                @if (perm.canCurrent('canCreate')) {
                <button class="btn btn-primary btn-sm" (click)="createNewBrand()">
                    <i class="fas fa-plus"></i> Nueva Marca
                </button>
                }
            </div>
            }
            <app-brand-list (selectEvent)="onBrandSelected($event)"></app-brand-list>
        </div>
    </div>
    }

    @if (!appSettings.isMobile() || showBrandDetail) {
    <div [class]="appSettings.isMobile() ? 'col-12' : 'col-md-9'">
        @if (selectedBrand) {
        <div class="panel p-3 mb-3">
            @if (!appSettings.isMobile()) {
            <h4 class="mb-3">{{ selectedBrand.isNew ? 'Nueva Marca' : 'Detalle de Marca' }}</h4>
            }
            <app-brand-form [brandForm]="brandForm" [(mode)]="mode" (formChange)="handleFormChange($event)">
                @if (mode() !== formMode.VIEW && !appSettings.isMobile()) {
                <div class="d-flex justify-content-end mt-3">
                    <button class="btn btn-primary btn-sm" (click)="saveBrand()">
                        <i class="fas fa-save"></i> Guardar
                    </button>
                    &nbsp;
                    <button class="btn btn-secondary btn-sm" (click)="cancelEdit()">
                        <i class="fas fa-times"></i> Cancelar
                    </button>
                </div>
                }
            </app-brand-form>
        </div>

        @if (!selectedBrand.isNew) {
        <app-model-list [brand]="selectedBrand"></app-model-list>
        }
        } @else if (!appSettings.isMobile()) {
        <div class="panel">
            <div class="panel-body d-flex flex-column align-items-center justify-content-center text-center p-5"
                style="min-height: 400px;">
                <div class="mb-3 p-4 rounded-circle bg-light d-inline-flex align-items-center justify-content-center"
                    style="width: 80px; height: 80px;">
                    <i class="fas fa-car text-info fa-2x"></i>
                </div>
                <h4 class="text-muted fw-bold mb-2">No hay selección</h4>
                <div class="text-muted small">Selecciona una marca de la lista para ver sus modelos y detalles.</div>
            </div>
        </div>
        }
    </div>
    }
</div>
